import React from "react";
import ReactDOM from "react-dom/client";
import { createRoot } from "react-dom/client";
import App from "./App.js";
import "./index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "@/components/ui/toaster.js";
import { AuthProvider } from "./context/AuthContext.js";

// Import this to initialize Firebase when the app starts.
// The import itself triggers the initialization code in firebase.ts.
import "./lib/firebase.ts";

// Create a QueryClient instance
const queryClient = new QueryClient();

/**
 * Unregister any active service workers.
 * This is a common workaround during development for SPAs to prevent
 * the service worker from incorrectly handling navigation routes.
 */
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then(function (registrations) {
      for (const registration of registrations) {
        registration.unregister();
      }
    })
    .catch(function (err) {
      console.log("Service Worker unregistration failed: ", err);
    });
}

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <App />
      </AuthProvider>
      <Toaster />
    </QueryClientProvider>
  </React.StrictMode>
);
